// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();
// faq tabs toggal end

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
     toggal_all_tabs_content(item.getAttribute('data-hendles'));
  });        
}
function toggal_all_tabs_content(tabs_data){
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  tabs_content_toggel.forEach(b => {
    if(b.getAttribute('data-hendles') == tabs_data){
         b.classList.add("active");
        document.querySelector(b.getAttribute('data-hendles')).style.display = 'block';
    }else{
       b.classList.remove("active");
       document.querySelector(b.getAttribute('data-hendles')).style.display = 'none';
    }
  });                   
}
let tabs_content  = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end

//newsletter popup
setTimeout(function(){
  var lastShownTime = localStorage.getItem('popupLastShownTime');
  var currentTime = new Date().getTime();
  var oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  console.log(!lastShownTime || (currentTime - lastShownTime) > oneDay);
  if (!lastShownTime || (currentTime - lastShownTime) > oneDay) {
    $('#newsletter-popup').fadeIn();
      localStorage.setItem('popupLastShownTime', currentTime);
  }
  if(window.location.href.includes('customer_posted=true')){
     $('#newsletter-popup').fadeIn();
  
  }
  $('.close-popup').click(function() {
    $('#newsletter-popup').fadeOut();
    if(window.location.href.includes('customer_posted=true')){
       window.location.replace('/');
    }
  });
  
  $(window).click(function(event) {
    if ($(event.target).is('#newsletter-popup')) {
      $('#newsletter-popup').fadeOut();
    }
  });
},5000);
//newsletter popup end

$('.slider_desktop_btn .cust_prev').click(function () {
  $('.slider_mobile_btn .swiper-button-prev ').trigger("click");
});

$('.slider_desktop_btn .cust_next').click(function () {
  $('.slider_mobile_btn .swiper-button-next ').trigger("click");
});

$('.read_more_btn').click(function() {
  $(this).closest('.pro_short_description').hide();
  $(this).closest('.pro_short_description').next('.pro_full_description').show();
});

$('.read_less_btn').click(function() {
  $(this).closest('.pro_full_description').hide();
  $(this).closest('.pro_full_description').prev('.pro_short_description').show();
});

$(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.js-acc-single-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
  if ($(window).width() < 749){  
    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
        $this = $(this),
        $next = $this.next();
  
      $next.slideToggle();
      $this.parent().toggleClass('open');
  
      if (!e.data.multiple) {
        $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
      };
    } 
  }
  var accordion = new Accordion($('#accordion'), false);
});  

$('.about_load').click(function() {
  $(this).closest('.image-with-text__text-short').hide();
  $(this).closest('.image-with-text__text-short').next('.image-with-text__text-full').show();
});

$('.pdp_load').click(function() {
  $(this).closest('.image-with-text__text-shortpdp').hide();
  $(this).closest('.image-with-text__text-shortpdp').next('.image-with-text__text-fullpdp').show();
});

$('.fou_btn_load').click(function() { 
  $(this).closest('.fou_content-short').hide();
  $(this).closest('.fou_content-short').next('.fou_content-full').show();
}); 

$('.fou_content-short[data-index]').hide();
$('.fou_content-short[data-index]:first').show();
$('.founder_img[data-index]').hide();
$('.founder_img[data-index]:first').show();
if($(window).innerWidth() <= 428) {
$('.founder_img.mobile_img_cls[data-index]:first').show();
}
$("ul.fou_btn a").click(function () { 
  $('ul.fou_btn a').removeClass('active_btn');
  $(this).addClass('active_btn');
  let currentTab = $(this).attr('id');
  $('.fou_content-short').hide();
  $('.founder_img').hide();
  $('.fou_content-full').hide();
  $('.fou_content-short[data-index="' + currentTab + '"]').show(); 
  $('.founder_img[data-index="' + currentTab + '"]').show(); 
});

var init = false;
function swiperCard() {
  if (window.innerWidth <= 750) {
    if (!init) {
      init = true;
      var swiper = new Swiper(".newsletter_icon_slide", {  
        direction: "horizontal",
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);

if (window.innerWidth <= 749) {
  var swiper2 = new Swiper(".newsletter_icon_slide_footer .swiper", {
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
}
if (window.innerWidth <= 989) {
  var swiper = new Swiper(".blg_slider", {
    direction: "horizontal",
    slidesPerView: 1,
    centeredSlides: false,
    spaceBetween: 0,
    navigation:{
      nextEl:".swiper-button-next",
      prevEl:".swiper-button-prev"
    },
    breakpoints: {
        275: {
          slidesPerView: 1,
        },
        481: {
          slidesPerView: 2,
        },
        750: {
          slidesPerView: 2.5,
        },
      },
   });
}

$('.desktop_progress_data[data-index]').hide();
if($(window).innerWidth() >= 428) {
$('.desktop_progress_data[data-index]:first').show();
}
$(document).on('click','.people_ques_item', function(){
  console.log(11);
  $('.people_ques_item').removeClass('ans_active');
  $(this).addClass('ans_active');
  let currentTab = $(this).attr('id');
  $('.desktop_progress_data').hide();  
  if($(window).innerWidth() >= 428) {
  $('.desktop_progress_data[data-index="' + currentTab + '"]').show();
  }
});

$("#sorting-dropdown").change(function() {
  var selectedOption = $(this).val();
  sortBlogPosts(selectedOption);
});

function sortBlogPosts(option) {
  var postsContainer = $(".blog-articles");
  var posts = postsContainer.children(".cust_sort_blog");

  switch (option) {
    case "title-ascending":
      posts.sort(function(a, b) {
        return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
      });
      break;
    case "title-descending":
      posts.sort(function(a, b) {
        return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
      });
      break;
    case "created-ascending":
      posts.sort(function(a, b) {
        var dateA = new Date($(a).find(".blog-post-date").text());
        var dateB = new Date($(b).find(".blog-post-date").text());
        return dateA - dateB;
      });
      break;
    case "created-descending":
      posts.sort(function(a, b) {
        var dateA = new Date($(a).find(".blog-post-date").text());
        var dateB = new Date($(b).find(".blog-post-date").text());
        return dateB - dateA;
      });
      break;
    default:
      // No sorting, maintain original order
      break;
  }

  postsContainer.empty().append(posts);
}

$(document).on('click','.read_short_des',function(){
  console.log(111);
   $('html, body').animate({scrollTop: $('section.scroll_content').offset().top }, 'slow');
    return false;
})

$('#sorting-dropdown').click(function(){
   $(this).toggleClass('active_sort_dropdown');
});
$(document).mouseup(function (e){
  var container = $("#sorting-dropdown");
  if (!container.is(e.target)
      && container.has(e.target).length === 0)
  {
      $('#sorting-dropdown').removeClass('active_sort_dropdown');
  }
});

var showPopup = window.location.search.includes('?registerpopupopen');
if(showPopup){
  window.history.replaceState({}, null, window.location.href.split('?')[0]); 
  $('.register_popup').css('display','block');
  
}

$('#reg_close').click(function() {
   $('.register_popup').css('display','none');
})

